"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultBrowserBehavior_1 = require("../browserbehavior/DefaultBrowserBehavior");

var DefaultModality_1 = require("../modality/DefaultModality");

var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");

var VideoTileState_1 = require("./VideoTileState");

var DefaultVideoTile = /*#__PURE__*/function () {
  function DefaultVideoTile(tileId, localTile, tileController, devicePixelRatioMonitor) {
    _classCallCheck(this, DefaultVideoTile);

    this.tileController = tileController;
    this.devicePixelRatioMonitor = devicePixelRatioMonitor;
    this.tileState = new VideoTileState_1.default();
    this.tileState.tileId = tileId;
    this.tileState.localTile = localTile;
    this.devicePixelRatioMonitor.registerObserver(this);
  }
  /**
   * Connect a video stream to a video element by setting the srcObject of the video element to the video stream.
   * @param videoStream The video stream input.
   * @param videoElement The video element input.
   * @param localTile Flag to indicate whether this is a local video.
   */


  _createClass(DefaultVideoTile, [{
    key: "destroy",
    value: function destroy() {
      this.devicePixelRatioMonitor.removeObserver(this);

      if (this.tileState.boundVideoElement && this.tileState.boundVideoElement.srcObject === this.tileState.boundVideoStream) {
        DefaultVideoTile.disconnectVideoStreamFromVideoElement(this.tileState.boundVideoElement, false);
      }

      this.tileState = new VideoTileState_1.default();
    }
  }, {
    key: "devicePixelRatioChanged",
    value: function devicePixelRatioChanged(newDevicePixelRatio) {
      this.tileState.devicePixelRatio = newDevicePixelRatio;
      this.sendTileStateUpdate();
    }
  }, {
    key: "id",
    value: function id() {
      return this.tileState.tileId;
    }
  }, {
    key: "state",
    value: function state() {
      return this.tileState.clone();
    }
  }, {
    key: "stateRef",
    value: function stateRef() {
      return this.tileState;
    }
  }, {
    key: "bindVideoStream",
    value: function bindVideoStream(attendeeId, localTile, mediaStream, contentWidth, contentHeight, streamId, externalUserId) {
      var tileUpdated = false;

      if (this.tileState.boundAttendeeId !== attendeeId) {
        this.tileState.boundAttendeeId = attendeeId;

        if (new DefaultModality_1.default(attendeeId).hasModality(DefaultModality_1.default.MODALITY_CONTENT)) {
          this.tileState.isContent = true;
        }

        tileUpdated = true;
      }

      if (this.tileState.boundExternalUserId !== externalUserId) {
        this.tileState.boundExternalUserId = externalUserId;
        tileUpdated = true;
      }

      if (this.tileState.localTile !== localTile) {
        this.tileState.localTile = localTile;
        tileUpdated = true;
      }

      if (this.tileState.boundVideoStream !== mediaStream) {
        this.tileState.boundVideoStream = mediaStream;
        tileUpdated = true;
      }

      if (this.tileState.videoStreamContentWidth !== contentWidth) {
        this.tileState.videoStreamContentWidth = contentWidth;
        tileUpdated = true;
      }

      if (this.tileState.videoStreamContentHeight !== contentHeight) {
        this.tileState.videoStreamContentHeight = contentHeight;
        tileUpdated = true;
      }

      if (this.tileState.streamId !== streamId) {
        this.tileState.streamId = streamId;
        tileUpdated = true;
      }

      if (tileUpdated) {
        this.sendTileStateUpdate();
      }
    }
  }, {
    key: "bindVideoElement",
    value: function bindVideoElement(videoElement) {
      var tileUpdated = false;

      if (this.tileState.boundVideoElement !== videoElement) {
        this.tileState.boundVideoElement = videoElement;
        tileUpdated = true;
      }

      if (this.tileState.boundVideoElement !== null) {
        if (this.tileState.videoElementCSSWidthPixels !== videoElement.clientWidth) {
          this.tileState.videoElementCSSWidthPixels = videoElement.clientWidth;
          tileUpdated = true;
        }

        if (this.tileState.videoElementCSSHeightPixels !== videoElement.clientHeight) {
          this.tileState.videoElementCSSHeightPixels = videoElement.clientHeight;
          tileUpdated = true;
        }
      } else {
        this.tileState.videoElementCSSWidthPixels = null;
        this.tileState.videoElementCSSHeightPixels = null;
      }

      if (tileUpdated) {
        this.sendTileStateUpdate();
      }
    }
  }, {
    key: "pause",
    value: function pause() {
      if (!this.tileState.paused) {
        this.tileState.paused = true;
        this.sendTileStateUpdate();
      }
    }
  }, {
    key: "unpause",
    value: function unpause() {
      if (this.tileState.paused) {
        this.tileState.paused = false;
        this.sendTileStateUpdate();
      }
    }
  }, {
    key: "markPoorConnection",
    value: function markPoorConnection() {
      if (this.tileState.poorConnection) {
        return false;
      }

      this.tileState.poorConnection = true;
      this.sendTileStateUpdate();
      return true;
    }
  }, {
    key: "unmarkPoorConnection",
    value: function unmarkPoorConnection() {
      if (!this.tileState.poorConnection) {
        return false;
      }

      this.tileState.poorConnection = false;
      this.sendTileStateUpdate();
      return true;
    }
  }, {
    key: "capture",
    value: function capture() {
      if (!this.tileState.active) {
        return null;
      }

      var canvas = document.createElement('canvas');
      var video = this.tileState.boundVideoElement;
      canvas.width = video.videoWidth || video.width;
      canvas.height = video.videoHeight || video.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      return ctx.getImageData(0, 0, canvas.width, canvas.height);
    }
  }, {
    key: "setStreamId",
    value: function setStreamId(id) {
      this.tileState.streamId = id; // `streamId` is not likely used by builders but we can't
      // be sure so send a tile state update just in case.

      this.tileController.sendTileStateUpdate(this.state());
    }
  }, {
    key: "sendTileStateUpdate",
    value: function sendTileStateUpdate() {
      this.updateActiveState();
      this.updateVideoStreamOnVideoElement();
      this.updateVideoElementPhysicalPixels();
      this.tileController.sendTileStateUpdate(this.state());
    }
  }, {
    key: "updateActiveState",
    value: function updateActiveState() {
      this.tileState.active = !!(!this.tileState.paused && !this.tileState.poorConnection && this.tileState.boundAttendeeId && this.tileState.boundVideoElement && this.tileState.boundVideoStream);
    }
  }, {
    key: "updateVideoElementPhysicalPixels",
    value: function updateVideoElementPhysicalPixels() {
      if (typeof this.tileState.videoElementCSSWidthPixels === 'number' && typeof this.tileState.videoElementCSSHeightPixels === 'number') {
        this.tileState.videoElementPhysicalWidthPixels = this.tileState.devicePixelRatio * this.tileState.videoElementCSSWidthPixels;
        this.tileState.videoElementPhysicalHeightPixels = this.tileState.devicePixelRatio * this.tileState.videoElementCSSHeightPixels;
      } else {
        this.tileState.videoElementPhysicalWidthPixels = null;
        this.tileState.videoElementPhysicalHeightPixels = null;
      }
    }
  }, {
    key: "updateVideoStreamOnVideoElement",
    value: function updateVideoStreamOnVideoElement() {
      if (this.tileState.active) {
        DefaultVideoTile.connectVideoStreamToVideoElement(this.tileState.boundVideoStream, this.tileState.boundVideoElement, this.tileState.localTile);
      } else {
        DefaultVideoTile.disconnectVideoStreamFromVideoElement(this.tileState.boundVideoElement, this.tileState.paused, this.tileController.keepLastFrameWhenPaused);
      }
    }
  }], [{
    key: "connectVideoStreamToVideoElement",
    value: function connectVideoStreamToVideoElement(videoStream, videoElement, localTile) {
      var _this = this;

      var transform = localTile && videoStream.getVideoTracks()[0].getSettings().facingMode !== 'environment' ? 'rotateY(180deg)' : '';
      DefaultVideoTile.setVideoElementFlag(videoElement, 'disablePictureInPicture', localTile);
      DefaultVideoTile.setVideoElementFlag(videoElement, 'disableRemotePlayback', localTile);

      if (videoElement.style.transform !== transform) {
        videoElement.style.transform = transform;
      }

      if (videoElement.hasAttribute('controls')) {
        videoElement.removeAttribute('controls');
      }

      if (!videoElement.hasAttribute('autoplay')) {
        videoElement.setAttribute('autoplay', 'true');
      } // playsinline is needed for video to play in iPhone in non-fullscreen mode.
      // See https://developer.apple.com/documentation/webkit/safari_tools_and_features/delivering_video_content_for_safari#3030250


      if (!videoElement.hasAttribute('playsinline')) {
        videoElement.setAttribute('playsinline', 'true');
      } // Note that setting the *attribute* 'muted' affects whether the element
      // is muted *by default* (`.defaultMuted`), not whether it is currently muted (`.muted`).
      // https://html.spec.whatwg.org/#dom-media-defaultmuted


      if (!videoElement.hasAttribute('muted')) {
        // The default value…
        videoElement.setAttribute('muted', 'true'); // … and the value right now.

        videoElement.muted = true;
      }

      if (videoElement.srcObject !== videoStream) {
        videoElement.srcObject = videoStream;
      }

      if (new DefaultBrowserBehavior_1.default().requiresVideoElementWorkaround()) {
        AsyncScheduler_1.default.nextTick(function () {
          return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
            return _regenerator.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return videoElement.play();

                  case 3:
                    _context.next = 7;
                    break;

                  case 5:
                    _context.prev = 5;
                    _context.t0 = _context["catch"](0);

                  case 7:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 5]]);
          }));
        });
      }
    }
    /**
     * Disconnect a video stream to a video element by clearing the srcObject of the video element.
     * This will also stop all the tracks of the current stream in the srcObject.
     * @param videoElement The video element input.
     * @param dueToPause A flag to indicate whether this function is called due to pausing video tile.
     *  If true, then we will not stop the stream's tracks and just clearing out the srcObject.
     * @param keepLastFrameWhenPaused If true and dueToPause is also true, then we will not clear out the srcObject of the
     * video element when it is paused and therefore, the last frame of the stream will be shown.
     */

  }, {
    key: "disconnectVideoStreamFromVideoElement",
    value: function disconnectVideoStreamFromVideoElement(videoElement, dueToPause) {
      var keepLastFrameWhenPaused = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!videoElement) {
        return;
      }

      if (dueToPause) {
        if (!keepLastFrameWhenPaused) {
          videoElement.srcObject = null;
          videoElement.style.transform = '';
        }
      } else {
        if (!videoElement.srcObject) {
          return;
        }

        videoElement.pause();
        videoElement.style.transform = '';
        DefaultVideoTile.setVideoElementFlag(videoElement, 'disablePictureInPicture', false);
        DefaultVideoTile.setVideoElementFlag(videoElement, 'disableRemotePlayback', false); // We must remove all the tracks from the MediaStream before
        // clearing the `srcObject` to prevent Safari from crashing.

        var mediaStream = videoElement.srcObject;
        var tracks = mediaStream.getTracks();

        var _iterator = _createForOfIteratorHelper(tracks),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var track = _step.value;
            track.stop();
            mediaStream.removeTrack(track);
          } // Need to yield the message loop before clearing `srcObject` to
          // prevent Safari from crashing.

        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (new DefaultBrowserBehavior_1.default().requiresVideoElementWorkaround()) {
          var prevSrcObject = videoElement.srcObject;
          AsyncScheduler_1.default.nextTick(function () {
            if (videoElement.srcObject === prevSrcObject) {
              videoElement.srcObject = null;
            }
          });
        } else {
          videoElement.srcObject = null;
        }
      }
    }
  }, {
    key: "setVideoElementFlag",
    value: function setVideoElementFlag(videoElement, flag, value) {
      if (flag in videoElement) {
        // @ts-ignore
        videoElement[flag] = value;
      }
    }
  }]);

  return DefaultVideoTile;
}();

exports.default = DefaultVideoTile;